function formatCurrency(number) {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(number);
}

export default formatCurrency;
